"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollRotation = void 0;
const react_1 = require("react");
const useOnWheel_1 = require("./useOnWheel");
function useScrollRotation() {
    const [rotation, setRotation] = react_1.useState(0);
    useOnWheel_1.useOnWheel(e => {
        setRotation(x => x + e.originalEvent.deltaX * 0.12);
    });
    return rotation;
}
exports.useScrollRotation = useScrollRotation;
//# sourceMappingURL=useScrollRotation.js.map